/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenHasPermission,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { ContactDetailsCustomer } from '../../resources/model/contact-details-customer.model';
import { ContactDetailsDebtorCommonFormState } from '../contact-details-debtor-common-tab/contact-details-debtor-common-form.service';
import {
  ContactDetailsSharedCommunicationListFormState,
  ContactDetailsSharedCommunicationListFormStateFactory,
} from '../contact-details-shared-communication-list-tab/contact-details-shared-communication-list-form.service';
import {
  ContactDetailsSharedCustomFieldsFormState,
  ContactDetailsSharedCustomFieldsFormStateFactory,
} from '../contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-form.service';

import {
  ContactDetailsSharedTermsPayerFormState,
  ContactDetailsSharedTermsPayerFormStateFactory,
} from '../contact-details-shared-terms-tab/contact-details-shared-terms-payer-form.service';

@Injectable()
export class ContactDetailsDebtorFormState extends FormState<ContactDetailsCustomer> {
  customFieldsForm: ContactDetailsSharedCustomFieldsFormState;
  termsForm: ContactDetailsSharedTermsPayerFormState;
  communicationForm: ContactDetailsSharedCommunicationListFormState;

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private commonForm: ContactDetailsDebtorCommonFormState,
              customFieldsFormFactory: ContactDetailsSharedCustomFieldsFormStateFactory,
              termsFormFactory: ContactDetailsSharedTermsPayerFormStateFactory,
              communicationFormFactory: ContactDetailsSharedCommunicationListFormStateFactory) {
    super(schemaFactory);

    this.customFieldsForm = customFieldsFormFactory.create();
    this.termsForm = termsFormFactory.create();
    this.communicationForm = communicationFormFactory.create();
  }

  build(customer: ContactDetailsCustomer): void {
    this.commonForm.build(customer.common);
    this.termsForm.build(customer.terms);
    this.communicationForm.build(customer.communication);
    this.customFieldsForm.build(customer.customFields);

    this.initSchema(customer);
    this.setChildForm('common', this.commonForm);
    this.setChildForm('terms', this.termsForm);
    this.setChildForm('communication', this.communicationForm);
    this.setChildForm('customFields', this.customFieldsForm);
  }

  protected buildSchema(_: ContactDetailsCustomer, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenHasPermission(BuilderPermission.Contacts.Debtor.CREATE_EDIT),
      children: {
        common: native(this.commonForm.group),
        terms: native(this.termsForm.group),
        communication: native(this.communicationForm.group),
        customFields: native(this.customFieldsForm.group),
      },
    });
  }
}
